import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "table-density-3",
  "use": "table-density-3-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"table-density-3\"><path d=\"M21 19H3v2h18v-2ZM21 11H3v2h18v-2ZM21 3H3v2h18V3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol